module.exports = __webpack_public_path__ + "static/img/parts-logo.fac91f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/parts-logo.png
// module id = u73K
// module chunks = 1